<template>
  <div ref="content" class="col-12 col-md-11 col-lg-10 col-xl-8 p-2 pt-5 p-sm-5 mx-auto mt-3 mt-sm-5 cert-page-content">
    <div class="cert-article px-2 px-sm-4">
      <h3 class="mb-4">Web Defacement</h3>
      <p>
        This is happening when an attacker penetrates into a website and modifies or replaces the original content and
        files with other content without permission.
      </p>

      <h4 class="mt-5 mb-4">How does website defacement happen?</h4>
      <p>
        The attacker will always look for website vulnerabilities like broken authentication, SQL injection,
        misconfigured server security Unauthorized access, Cross-site scripting (XSS), DNS hijacking, Malware infection,
        and many others to have administrator access and be able to change website data.
      </p>

      <h4 class="mt-5 mb-4">The motives behind website defacement </h4>
      <ul>
        <li>To ruin a person or company’s reputation</li>
        <li>To take revenge</li>
        <li>To prove a point (Hacktivist)</li>
        <li>To teach a lesson</li>
        <li>For political reasons, like damaging a political party’s image</li>
        <li>To gain popularity in the cyber security community</li>
        <li>To get ransom by asking money to bring back the website to its original version</li>
        <li>To advertise the competitor’s product/service</li>
        <li>To enjoy and feel empowered for their accomplishments of successful web defacement attempts.</li>
      </ul>

      <h4 class="mt-5 mb-4">How do I detect website defacement?</h4>
      <p>
        If an attacker has defaced your website, you should fix it as soon as possible. The best course of action is to
        prevent attacks in the first place, but no security is perfect. So taking a defense-in-depth approach also means
        monitoring your system to detect when an attacker has successfully launched a compromised system.
      </p>

      <h4 class="mt-5 mb-4">How to prevent website defacement attacks?</h4>
      <ul>
        <li>Secure your database</li>
        <li>Secure your codes mostly from former employees</li>
        <li>Use the Principle of Least Privilege</li>
        <li>Avoid default admin directory and admin email</li>
        <li>Limit file uploads</li>
        <li>Avoid displaying overly detailed error messages on your site</li>
        <li>Use SSL/TLS</li>
        <li>Scan for vulnerabilities</li>
        <li>Defend against Cross-Site Scripting (XSS)</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "GuideIncident"
}
</script>
